/* Paul & Romi · Video-Schleifen ohne Ladezeit-Kosten (snippets/pr-video.liquid). Leitstand 07.10.2026.
   Quelle erst nach window.load und nur im Bild (200 px Vorlauf); außerhalb des Bilds pausiert.
   Mobil (≤ 749 px) data-src-m, sonst data-src-d; langsame Verbindung (2g/3g) die 480p-Fassung.
   „Daten sparen“ oder „Bewegung reduzieren“: nur das Posterbild. Pause-Knopf, Nutzerpause bleibt bestehen. */
(function () {
  if (window.__prVideo) return;
  window.__prVideo = true;
  var mqM = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  var mqR = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var conn = navigator.connection || {};
  var loaded = document.readyState === 'complete';
  var queue = [];
  window.addEventListener('load', function () { loaded = true; queue.splice(0).forEach(function (f) { f(); }); });

  function pick(v) {
    if (conn.saveData) return '';
    var mobil = mqM && mqM.matches;
    var slow = /(^|-)2g$|^3g$/.test(conn.effectiveType || '');
    var d = v.getAttribute('data-src-d'), dl = v.getAttribute('data-src-d-low');
    var m = v.getAttribute('data-src-m'), ml = v.getAttribute('data-src-m-low');
    if (mobil) return (slow ? (ml || m) : (m || ml)) || d || '';
    return (slow ? (dl || d) : (d || dl)) || m || '';
  }

  function init(host) {
    if (host.__prVideo) return;
    host.__prVideo = true;
    var v = host.querySelector('.pr-video__film');
    var btn = host.querySelector('[data-pr-video-toggle]');
    if (!v) return;
    var visible = false, userPaused = false;
    function stop() { if (!v.paused) v.pause(); }
    function sync() {
      var s = pick(v);
      if (!s || (mqR && mqR.matches)) { stop(); v.classList.remove('is-playing'); if (btn) btn.hidden = true; return; }
      if (btn) btn.hidden = false;
      if (!visible || userPaused) { stop(); return; }
      if (!loaded) { queue.push(sync); return; }
      if (v.getAttribute('src') !== s) v.setAttribute('src', s);
      v.muted = true;
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }
    v.addEventListener('playing', function () { v.classList.add('is-playing'); });
    if (btn) btn.addEventListener('click', function () {
      userPaused = !userPaused;
      btn.setAttribute('aria-pressed', String(userPaused));
      btn.textContent = userPaused ? 'Abspielen' : 'Pause';
      sync();
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (x) { visible = x.isIntersecting; }); sync(); }, { rootMargin: '200px 0px' }).observe(host);
    } else { visible = true; }
    [mqM, mqR].forEach(function (mq) { if (mq && mq.addEventListener) mq.addEventListener('change', sync); });
    sync();
  }

  function scan(root) { (root || document).querySelectorAll('[data-pr-video]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
